import Vue from 'vue';
import Vuex from 'vuex';
import modules from './modules';
import subscriptionManager from 'vuex-subscription-manager';

Vue.use(Vuex);

const subscriptions = subscriptionManager(modules);

export default new Vuex.Store({
  modules: {
    ...modules,
  },
  plugins: [subscriptions],

});
